const info = {
    $schema: '../assetlist.schema.json',
    chain_name: 'archway',
    assets: [
        {
            description: 'Archway is a smart contract platform in the Cosmos ecosystem designed to reward developers by providing them with a share of transaction fees generated by their applications.',
            extended_description: 'Archway aims to incentivize developers by sharing a portion of the transaction fees generated by their decentralized applications (dApps) built on the platform. This innovative approach helps align the interests of developers with the network\'s growth and sustainability. Archway\'s native token, ARCH, is used for staking, governance, and distributing rewards to developers. By leveraging the Cosmos SDK, Archway ensures interoperability and scalability, allowing developers to build and deploy efficient and high-performance dApps.',
            denom_units: [
                {
                    denom: 'aarch',
                    exponent: 0
                },
                {
                    denom: 'uarch',
                    exponent: 12
                },
                {
                    denom: 'arch',
                    exponent: 18
                }
            ],
            base: 'aarch',
            name: 'Archway',
            display: 'arch',
            symbol: 'ARCH',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.svg'
            },
            coingecko_id: 'archway',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.svg',
                    theme: {
                        primary_color_hex: '#fc4c04'
                    }
                }],
            socials: {
                website: 'https://archway.io/',
                twitter: 'https://twitter.com/archwayHQ'
            },
            type_asset: 'sdk.coin'
        },
        {
            description: 'BackBone Labs Liquid Staked Archway',
            type_asset: 'cw20',
            address: 'archway12yurzx8zynv3ck7uh4tucre48tqsm4fac4hfk9p3l24qs2cn08dqr684cg',
            denom_units: [{
                    denom: 'archway12yurzx8zynv3ck7uh4tucre48tqsm4fac4hfk9p3l24qs2cn08dqr684cg',
                    exponent: 0
                }, {
                    denom: 'bARCH',
                    exponent: 18
                }],
            base: 'archway12yurzx8zynv3ck7uh4tucre48tqsm4fac4hfk9p3l24qs2cn08dqr684cg',
            name: 'BackBone Labs Liquid Staked Archway',
            display: 'bARCH',
            symbol: 'bARCH',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/barch.png'
            },
            traces: [{
                    type: 'liquid-stake',
                    counterparty: {
                        chain_name: 'archway',
                        base_denom: 'aarch'
                    },
                    provider: 'BackBoneLabs'
                }],
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/barch.png'
                }]
        },
        {
            description: 'Architects Token',
            type_asset: 'cw20',
            address: 'archway16kxu278xtwa9ql20yhgk9smk2k6ke74hsxeesf36c9dhxqc5zyksh8ykwu',
            denom_units: [{
                    denom: 'archway16kxu278xtwa9ql20yhgk9smk2k6ke74hsxeesf36c9dhxqc5zyksh8ykwu',
                    exponent: 0
                }, {
                    denom: 'TOKN',
                    exponent: 18
                }],
            base: 'archway16kxu278xtwa9ql20yhgk9smk2k6ke74hsxeesf36c9dhxqc5zyksh8ykwu',
            name: 'Architects Token',
            display: 'TOKN',
            symbol: 'TOKN',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/tokn.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/tokn.png'
                }]
        },
        {
            description: 'ERIS liquid staked ARCH',
            type_asset: 'cw20',
            address: 'archway1fwurjg7ah4v7hhs6xsc3wutqpvmahrfhns285s0lt34tgfdhplxq6m8xg5',
            denom_units: [{
                    denom: 'cw20:archway1fwurjg7ah4v7hhs6xsc3wutqpvmahrfhns285s0lt34tgfdhplxq6m8xg5',
                    exponent: 0
                }, {
                    denom: 'ampARCH',
                    exponent: 6
                }],
            base: 'cw20:archway1fwurjg7ah4v7hhs6xsc3wutqpvmahrfhns285s0lt34tgfdhplxq6m8xg5',
            name: 'ERIS Amplified ARCH',
            display: 'ampARCH',
            symbol: 'ampARCH',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/amparch.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/amparch.png',
                    theme: {
                        primary_color_hex: '#5c84cc'
                    }
                }]
        },
        {
            description: 'The native token of Vidulum',
            denom_units: [{
                    denom: 'ibc/1BCF1FCAFE3568E234787EDFDA12460BD8931B17FE6A729DCD60FAD845558DA1',
                    exponent: 0,
                    aliases: ['uvdl']
                }, {
                    denom: 'vdl',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/1BCF1FCAFE3568E234787EDFDA12460BD8931B17FE6A729DCD60FAD845558DA1',
            name: 'Vidulum',
            display: 'vdl',
            symbol: 'VDL',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'vidulum',
                        base_denom: 'uvdl',
                        channel_id: 'channel-24'
                    },
                    chain: {
                        channel_id: 'channel-110',
                        path: 'transfer/channel-110/uvdl'
                    }
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg'
            },
            images: [{
                    image_sync: {
                        chain_name: 'vidulum',
                        base_denom: 'uvdl'
                    },
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg',
                    theme: {
                        primary_color_hex: '#3454bc'
                    }
                }]
        },
        {
            description: 'Astrovault AXV',
            type_asset: 'cw20',
            address: 'archway1ecjefhcf8r60wtfnhwefrxhj9caeqa90fj58cqsaafqveawn6cjs5znd2n',
            denom_units: [{
                    denom: 'cw20:archway1ecjefhcf8r60wtfnhwefrxhj9caeqa90fj58cqsaafqveawn6cjs5znd2n',
                    exponent: 0
                }, {
                    denom: 'AXV',
                    exponent: 6
                }],
            base: 'cw20:archway1ecjefhcf8r60wtfnhwefrxhj9caeqa90fj58cqsaafqveawn6cjs5znd2n',
            name: 'Astrovault AXV',
            display: 'AXV',
            symbol: 'AXV',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/axv.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/axv.svg'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/axv.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/axv.svg',
                    theme: {
                        primary_color_hex: '#141434'
                    }
                }],
            coingecko_id: 'astrovault'
        },
        {
            description: 'Wrapped ARCH',
            type_asset: 'cw20',
            address: 'archway1msc3fa4e2mh73y760qmjd3wfkzr98nl26f36xgt2xnhuw6ay3scs42zeue',
            denom_units: [{
                    denom: 'cw20:archway1msc3fa4e2mh73y760qmjd3wfkzr98nl26f36xgt2xnhuw6ay3scs42zeue',
                    exponent: 0
                }, {
                    denom: 'wARCH',
                    exponent: 18
                }],
            base: 'cw20:archway1msc3fa4e2mh73y760qmjd3wfkzr98nl26f36xgt2xnhuw6ay3scs42zeue',
            name: 'Wrapped ARCH',
            display: 'wARCH',
            symbol: 'wARCH',
            traces: [{
                    type: 'wrapped',
                    counterparty: {
                        chain_name: 'archway',
                        base_denom: 'aarch'
                    },
                    provider: 'Archway'
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.svg'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.svg',
                    theme: {
                        primary_color_hex: '#000000'
                    }
                }]
        },
        {
            description: 'Circle\'s USDC Noble on Archway ',
            denom_units: [{
                    denom: 'ibc/43897B9739BD63E3A08A88191999C632E052724AB96BD4C74AE31375C991F48D',
                    exponent: 0,
                    aliases: ['uusdc']
                }, {
                    denom: 'usdc',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/43897B9739BD63E3A08A88191999C632E052724AB96BD4C74AE31375C991F48D',
            name: 'USDC (Noble)',
            display: 'usdc',
            symbol: 'USDC',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'noble',
                        base_denom: 'uusdc',
                        channel_id: 'channel-12'
                    },
                    chain: {
                        channel_id: 'channel-29',
                        path: 'transfer/channel-29/uusdc'
                    }
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg'
            },
            images: [{
                    image_sync: {
                        chain_name: 'noble',
                        base_denom: 'uusdc'
                    },
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg',
                    theme: {
                        circle: true,
                        primary_color_hex: '#2775CA'
                    }
                }]
        },
        {
            description: 'Wrapped USDC (Noble)',
            type_asset: 'cw20',
            address: 'archway1gaf9nw7n8v5lpjz9caxjpps006kxfcrzcuc8y5qp4clslhven2ns2g0ule',
            denom_units: [{
                    denom: 'cw20:archway1gaf9nw7n8v5lpjz9caxjpps006kxfcrzcuc8y5qp4clslhven2ns2g0ule',
                    exponent: 0
                }, {
                    denom: 'wUSDC',
                    exponent: 6
                }],
            base: 'cw20:archway1gaf9nw7n8v5lpjz9caxjpps006kxfcrzcuc8y5qp4clslhven2ns2g0ule',
            name: 'Wrapped USDC',
            display: 'wUSDC',
            symbol: 'wUSDC',
            traces: [{
                    type: 'wrapped',
                    counterparty: {
                        chain_name: 'archway',
                        base_denom: 'ibc/43897B9739BD63E3A08A88191999C632E052724AB96BD4C74AE31375C991F48D'
                    },
                    provider: 'Archway'
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wUsdc-noble.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wUsdc-noble.svg'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wUsdc-noble.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wUsdc-noble.svg',
                    theme: {
                        primary_color_hex: '#000000'
                    }
                }]
        },
        {
            description: 'The native token of Migaloo Chain',
            denom_units: [{
                    denom: 'ibc/3F882513A0CCD1C4110ACB7C6C761AC7B48974C9D2D439CD6F652F9B44362518',
                    exponent: 0,
                    aliases: ['uwhale']
                }, {
                    denom: 'whale',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/3F882513A0CCD1C4110ACB7C6C761AC7B48974C9D2D439CD6F652F9B44362518',
            name: 'Migaloo',
            display: 'whale',
            symbol: 'WHALE',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'migaloo',
                        base_denom: 'uwhale',
                        channel_id: 'channel-141'
                    },
                    chain: {
                        channel_id: 'channel-184',
                        path: 'transfer/channel-184/uwhale'
                    }
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.svg'
            },
            images: [{
                    image_sync: {
                        chain_name: 'migaloo',
                        base_denom: 'uwhale'
                    },
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.svg',
                    theme: {
                        primary_color_hex: '#1c1c1c'
                    }
                }]
        },
        {
            description: 'CULT - Less Brainwashing, More Utility',
            extended_description: 'CULT - Less Brainwashing, More Utility\n\n$CULT is more than a token; it\'s your key to ascend within the Order of Architects. Each token empowers you to mint and upgrade Architect NFTs, navigating through rites that elevate their mystical powers. Engage directly in our unique Streamswap process, beginning with a USDC deposit, transitioning smoothly into $CULT.\n\nFair Launch: Our token launch excludes whitelists and bots, ensuring a transparent and equitable distribution for all. Streamswap Mechanics: Deposit $USDC during the 72-hour Bootstrapping Phase, followed by a 1-hour Streaming Phase to convert into $CULT, ensuring a smooth and fair token distribution.',
            denom_units: [{
                    denom: 'ibc/7364C29ED876F05A82628B738AA2F0D53724991FD0220858570D7A3844B67F58',
                    exponent: 0,
                    aliases: ['ucult']
                }, {
                    denom: 'CULT',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/7364C29ED876F05A82628B738AA2F0D53724991FD0220858570D7A3844B67F58',
            name: 'CULT',
            display: 'CULT',
            symbol: 'CULT',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/cult.png'
            },
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1qdvwftqd8ml6t9w6dmj97m03ck5ghqqmd8y7cm/cult',
                        channel_id: 'channel-1429'
                    },
                    chain: {
                        channel_id: 'channel-1',
                        path: 'transfer/channel-1/factory/osmo1qdvwftqd8ml6t9w6dmj97m03ck5ghqqmd8y7cm/cult'
                    }
                }],
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/cult.png',
                    image_sync: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1qdvwftqd8ml6t9w6dmj97m03ck5ghqqmd8y7cm/cult'
                    }
                }]
        }
    ]
};
export default info;
